/**
 * SuggestionChip — the discoverability scaffold. Framed as the car's offers,
 * not menu items, so the conversational frame holds. `warn` tone for things
 * that need attention (calm clay, never alarming red).
 */
import type { ReactNode } from 'react';

export function SuggestionChip({
  icon,
  children,
  tone = 'default',
  onClick,
}: {
  icon?: ReactNode;
  children: ReactNode;
  tone?: 'default' | 'warn';
  onClick?: () => void;
}) {
  const warn = tone === 'warn';
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'w-full text-start flex items-center gap-3 rounded-2xl px-[18px] py-[15px]',
        'text-[16px] font-medium border min-h-[52px]',
        'shadow-[0_10px_22px_-20px_rgba(50,60,50,0.5)] transition-transform active:scale-[0.99]',
        warn ? 'bg-kol-clay-soft border-[#ecd9c9] text-[#8c5a36]' : 'bg-kol-card border-kol-line text-kol-ink',
      ].join(' ')}
    >
      {icon && (
        <span className="text-[19px] opacity-85" aria-hidden>
          {icon}
        </span>
      )}
      <span>{children}</span>
    </button>
  );
}
